import { BookMarked, CheckCircle2, Target } from 'lucide-react';
import Grid from '../ui/Grid';
import Card from '../ui/Card';
import './EducationStatsStrip.css';

export type EducationStatsStripProps = {
    total: number;
    completed: number;
    inProgress: number;
};

function EducationStatsStrip({
    total,
    completed,
    inProgress,
}: EducationStatsStripProps) {
    return (
        <Grid minItemWidth={200} gap="md" className="education-stats-strip">
            <Card variant="compact">
                <Card.Header>
                    <BookMarked size={18} />
                    Total courses
                </Card.Header>
                <Card.Body>
                    <span className="stats-strip__value">{total}</span>
                </Card.Body>
            </Card>
            <Card variant="compact">
                <Card.Header>
                    <CheckCircle2 size={18} />
                    Completed
                </Card.Header>
                <Card.Body>
                    <span className="stats-strip__value">{completed}</span>
                </Card.Body>
            </Card>
            <Card variant="compact">
                <Card.Header>
                    <Target size={18} />
                    In progress
                </Card.Header>
                <Card.Body>
                    <span className="stats-strip__value">{inProgress}</span>
                </Card.Body>
            </Card>
        </Grid>
    );
}

export default EducationStatsStrip;
